import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_channel_list = _resolveComponent("channel-list")!
  const _component_channel_list_non = _resolveComponent("channel-list-non")!

  return (_ctx.user !== null)
    ? (_openBlock(), _createBlock(_component_channel_list, { key: 0 }))
    : (_openBlock(), _createBlock(_component_channel_list_non, { key: 1 }))
}